import React from "react";
import { SovosBox, SovosStep, SovosStepButton, SovosStepLabel, SovosStepper, SovosTypography } from "mosaic-react";
import { FLOW_STEP_INDEX, STEPS } from "../../store/views/MappingFlow/ColumnMappingCanvas/constants";

const StatusBadge = ({ label, dotColor, bgColor, borderColor, textColor }) => (
    <SovosBox
        sx={{
            display: "inline-flex",
            alignItems: "center",
            gap: 0.5,
            px: 1,
            py: 0.25,
            borderRadius: 3,
            bgcolor: bgColor,
            border: "1px solid",
            borderColor,
        }}
    >
        <SovosBox sx={{ width: 8, height: 8, borderRadius: "50%", bgcolor: dotColor, flexShrink: 0 }} />
        <SovosTypography variant="caption" sx={{ color: textColor, fontWeight: 600, fontSize: 12 }}>
            {label}
        </SovosTypography>
    </SovosBox>
);

const ColumnMappingFlowHeader = ({ step, frameworkName, imported, actions = [], onStepClick }) => {
    const showStatus = step !== undefined;

    const statusBadge = () => {
        if (imported) {
            return <StatusBadge label="Proceeded" dotColor="success.main" bgColor="success.light" borderColor="success.light" textColor="success.dark" />;
        }
        if (step === FLOW_STEP_INDEX.FixData) {
            return <StatusBadge label="Waiting import" dotColor="primary.main" bgColor="primary.light" borderColor="primary.light" textColor="primary.dark" />;
        }
        return <StatusBadge label="Under mapping" dotColor="warning.main" bgColor="warning.light" borderColor="warning.light" textColor="warning.dark" />;
    };

    if (!showStatus) return null;

    return (
        <SovosBox
            sx={{
                borderBottom: "1px solid",
                borderColor: "divider",
                bgcolor: "background.paper",
                px: 3,
                pt: 1.5,
                pb: 0,
            }}
        >
            <SovosTypography variant="caption" color="primary.main" fontWeight={600} sx={{ display: "block", mb: 0.5 }}>
                Files
            </SovosTypography>

            <SovosBox sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 2, mb: 1.5 }}>
                <SovosBox sx={{ display: "flex", alignItems: "center", gap: 1.5, minWidth: 0 }}>
                    <SovosTypography variant="h4" fontWeight={700} noWrap>
                        {frameworkName || " "}
                    </SovosTypography>
                    {statusBadge()}
                </SovosBox>

                {actions.length > 0 && (
                    <SovosBox sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1, flexShrink: 0 }}>
                        {actions.map((action) => action)}
                    </SovosBox>
                )}
            </SovosBox>

            <SovosStepper activeStep={step - FLOW_STEP_INDEX.ChooseEntity} sx={{ pb: 1.5, bgcolor: "transparent" }}>
                {STEPS.map((label, idx) => {
                    const stepNum = idx + 1;
                    const isDone = imported ? true : stepNum < step;
                    return (
                        <SovosStep key={label} completed={isDone}>
                            {isDone && onStepClick ? (
                                <SovosStepButton onClick={() => onStepClick(stepNum)}>
                                    {label}
                                </SovosStepButton>
                            ) : (
                                <SovosStepLabel>{label}</SovosStepLabel>
                            )}
                        </SovosStep>
                    );
                })}
            </SovosStepper>
        </SovosBox>
    );
};

export default ColumnMappingFlowHeader;
